export default function CaseSection() {
  const cases = [
    {
      brand: '时尚品牌A',
      result: '品牌搜索量提升320%',
      desc: '通过KOL矩阵投放与内容共创，实现品牌声量爆发式增长',
      image: 'https://readdy.ai/api/search-image?query=Fashion%20brand%20social%20media%20content%20display%20on%20smartphone%20screen%2C%20minimalist%20aesthetic%20with%20warm%20cream%20background%2C%20clean%20product%20photography%20style%2C%20soft%20lighting&width=600&height=400&seq=case-01&orientation=landscape',
    },
    {
      brand: '科技公司B',
      result: '用户转化率提升185%',
      desc: '精准信息流投放策略，帮助品牌以更低成本触达高价值用户',
      image: 'https://readdy.ai/api/search-image?query=Technology%20company%20digital%20marketing%20dashboard%20with%20growth%20charts%2C%20modern%20clean%20interface%2C%20warm%20office%20setting%2C%20professional%20analytics%20visualization&width=600&height=400&seq=case-02&orientation=landscape',
    },
    {
      brand: '食品品牌C',
      result: '单月GMV突破800万',
      desc: '直播带货全案策划，从选品到话术到投流的一站式运营',
      image: 'https://readdy.ai/api/search-image?query=Livestream%20ecommerce%20studio%20setup%20with%20products%20display%2C%20professional%20lighting%20and%20camera%2C%20warm%20and%20inviting%20atmosphere%2C%20modern%20broadcasting%20room&width=600&height=400&seq=case-03&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            合作案例
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            助力品牌实现增长突破
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            每一个案例都是一次深度合作，每一个数字背后都是真实效果
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cases.map((c) => (
            <div
              key={c.brand}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.brand}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="text-xs text-foreground-500 mb-1">{c.brand}</div>
                <h4 className="text-lg font-heading font-semibold text-accent-600 mb-2">{c.result}</h4>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}